import api from "../api";
import { ResaleStore } from "./types/resale.types";

export const verifyResaleCode = async (
  referral: string
): Promise<ResaleStore> => {
  const res = await api.post<ResaleStore>(
    "users/availability/resale-code/validate",
    { referral },
  );
  return res.data;
};
